/**
    商品列表
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家入驻申请</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="7">
        <div class="leftaside">
          <h4>商家入驻指南</h4>
          <div class="left_product">
            <el-menu
              default-active="5"
              class="el-menu-vertical-demo"
              :unique-opened='true'
              background-color="#f7f8f8"
            >
              <el-submenu index="0">
                <template slot="title">入驻流程</template>
                <el-menu-item index="0-1">商家提交申请</el-menu-item>
                <el-menu-item index="0-2">平台审核资质</el-menu-item>
                <el-menu-item index="0-3">商家缴纳费用</el-menu-item>
                <el-menu-item index="0-4">店铺开通</el-menu-item>
              </el-submenu>
             <el-menu-item index="2">
                <template slot="title"
                  >签订入驻协议</template
                >
              </el-menu-item>
              <el-menu-item index="3">
                <template slot="title"
                  >选择店铺类型</template
                >
              </el-menu-item>
              <el-menu-item index="4">
                <template slot="title"
                  >平台审核</template
                >
              </el-menu-item>
              <el-menu-item index="5">
                <template slot="title"
                  >合同签订及缴费</template
                >
              </el-menu-item>
              <el-menu-item index="6">
                <template slot="title"
                  >店铺开通</template
                >
              </el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="leftaside">
          <h4>平台联系方式</h4>
          <div class="left_product" style="padding: 20px">
            <p>电话：400-888-2816</p>
            <p>邮箱：sczx1@xunyou021.com</p>
          </div>
        </div>
      </el-col>
      <el-col :span="17" class="rightaside">
        <div>
          <h3 class="greenStatus" v-if="isSuccess==2"> 审核已通过</h3>
          <h3 class="greenStatus" v-if="isSuccess==4"> 已支付，等待审核</h3>
          <!-- <h3 v-show="isSuccess==false?true:false" class="blueStatus"> 入驻申请已经提交，请等待管理员审核</h3> -->
          <el-divider></el-divider>
          <el-row class="outBoxLine">
            <el-col class="titleBorderline" :span="24"><div class="grid-content bg-purple">付款清单列表</div></el-col>
            <el-col class="borderline" :span="4"><div class="grid-content bg-purple">收费标准:</div></el-col>
            <el-col class="borderline" :span="8"><div class="grid-content bg-purple-light">{{payForList.margin||'--'}}</div></el-col>
            <el-col class="borderline" :span="4"><div class="grid-content bg-purple">开店时长:</div></el-col>
            <el-col class="borderline" :span="8"><div class="grid-content bg-purple-light">{{payForList.time||'--'}}</div></el-col>

            <el-col class="borderline" :span="4"><div class="grid-content bg-purple"></div>经营类:</el-col>
            <el-col class="borderline" :span="8"><div class="grid-content bg-purple-light OneLineDisplay" :title="payForList.types">{{payForList.types||'--'}}</div></el-col>            
            <el-col class="borderline" :span="4"><div class="grid-content bg-purple-light">开店保证金:</div></el-col>
            <el-col class="borderline" :span="8"><div class="grid-content bg-purple-light">{{MarginMoney||0}} 元</div></el-col>
            <!-- <el-col class="borderline total" :span="24"><div class="grid-content bg-purple-light">总共: {{total}} 元</div></el-col> -->
        </el-row>
        <el-row style="margin-top:10px;color:#78b942">
          注意：请先支付保证金，再支付店铺费用
        </el-row>
       <div class="payButton">
            <el-button v-if="isShow&&isPayMargin==1" size="small" @click="payPromiseMoney()">支付保证金</el-button>
            <el-button :disabled='isdisabled' v-if="isSuccess==2" size="small" @click="payMoney()">支付店铺费用</el-button>
            <!--通过判断确定显示和不显示 isBaselineVersion是否是基线版本-->
            <!-- <el-button v-if="isShow&isBaselineVersion" size="small" @click="payPromiseMoney()">支付保证金</el-button> -->
       </div>
        </div>
      </el-col>
    </el-row>
    <!-- 支付弹框弹框 -->
    <el-dialog
        :visible.sync="paydialogVisible"
        :close-on-click-modal='false'
        width="30%"
        center
        class="paydialogBox">
        <div class="textCenter">
          <!-- <p>请向此账号 ( <i>150xxxx7321</i> ) 支付 {{total}} 元</p> -->
          <el-form  :rules="rules" ref="sizeForm" :model="sizeForm" label-width="110px" size="mini" >
             <el-form-item label="支付凭证" prop="payproof" class="myproof">
                 <el-upload
                         name="files"
                         class="avatar-uploader"
                         :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                         :show-file-list="false"
                         :on-success="handleAvatarSuccess"
                         :before-upload="beforeAvatarUpload">
                         <img v-if="sizeForm.payproof" :src="urlImg" class="avatar">
                         <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                 </el-upload>
                 </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitApply()" class="buttonBgd">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 支付保证金弹窗 -->
    <el-dialog
        :visible.sync="paydialogcanVisible"
        :close-on-click-modal='false'
        width="30%"
        center
        class="paydialogBox">
        <div class="textCenter">
          <!-- <p>请向此账号 ( <i>150xxxx7321</i> ) 支付 {{total}} 元</p> -->
          <el-form  :rules="rules" ref="sizeForm" :model="sizeForm" label-width="110px" size="mini" >
             <el-form-item label="支付凭证" prop="paypmarginroof" class="myproof">
                 <el-upload
                         name="files"
                         class="avatar-uploader"
                         :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
                         :show-file-list="false"
                         :on-success="handlemarginAvatarSuccess"
                         :before-upload="beforemarginAvatarUpload">
                         <img v-if="sizeForm.paypmarginroof" :src="marginurlImg" class="avatar">
                         <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                 </el-upload>
                 </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitcanApply()" class="buttonBgd">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import { merchantpayMoney,merchants_pay_list,getMercharntStep,getMercharntStatus,openMargin,checkMargin,addMargin,payMargin } from '@/api/xunyou'
// import {mapState} from 'vuex'
export default {
  data() {
    return {
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        isPayMoney:true,
        payForList:{}, //付费清单
        paydialogcanVisible:false,
        paydialogVisible:false,
        total:0, //总金额
        urlImg:'', // 用来图片预览的
        marginurlImg:'', // 用来图片预览的
        payForImg:'',
        payFormarginImg:'',
        isSuccess:'',
        isShow:'',
        remittanceUrl:"", //用来新增保证金记录
        MarginMoney:0,
        isdisabled:true, // 支付店铺费用
        sizeForm: {
            payproof:'',
            paypmarginroof:'',
        },
        rules: {
            payproof:[{ required: true, message: "不能为空,请上传支付凭证", trigger: ["blur", "change"] },],          
            paypmarginroof:[{ required: true, message: "不能为空,请上传支付保证金凭证", trigger: ["blur", "change"] },],          
        },
        
    };
  },
  // 注册组件
  components: {},
  // computed:{
  //   ...mapState(['isBaselineVersion'])
  // },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){
    this.getPayFor()
    this.goToSettleInStep()
    this.goToSettleIn()
    this.getMarginIn()
    this.getMargin()
    this.getMarginStatus()//是否支付保证金
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 查询付费清单
    getPayFor(){
      merchants_pay_list({name:this.userInfo.loginName})
            .then(res => {
              if (res.code == 0) {
                // this.statusType(res.data)
                // console.log(res)
                this.payForList = res.data
                this.total = parseInt(res.data.margin) + parseInt(this.MarginMoney);
              } else {
                this.$message({
                  type: 'info',
                  message: '查询失败，请稍后再试！'
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('查询失败，请稍后再试！')
            })     
    },

    // 点击支付按钮
    payMoney(){
      this.paydialogVisible=true
    },
    // 点击支付保证金按钮，同支付按钮
    payPromiseMoney(){
      this.paydialogcanVisible=true
    },

    // 状态判断，不同的状态跳到相应的页面
    statusType(status){
       switch(status) {
            case 1:
                return  this.$router.push(`/merchantApply`)
                break;
            case 2:
                 return this.$router.push('/merchantStatus')
                break;
            case 3:
                 return this.$router.push('/merchantpayFor')
                break;
            case 4:
                 return this.$router.push('/storeOpen')
            default:                
                return '--'
        } 
    },
    //查询保证金开关是否开启
    getMarginIn(){
      openMargin().then(res => {
        if(res.code==0){
          this.isShow = res.data
        }else{
           this.isShow = false
        }
      }).catch(err =>{
        this.$message.error('查询失败，请稍后再试！')
      })
    },
    // 查询保证金
    getMargin(){
      const bxscId = localStorage.getItem('bxscId')
      // console.log(bxscId)
      checkMargin({bxscId}).then(res => {
        // console.log(res)
        if(res.code==0){
          this.MarginMoney = res.data
          localStorage.setItem("MarginMoney", res.data)
        }
      })
    },
    // 状态查询
    goToSettleIn(){
      getMercharntStatus({username:this.userInfo.loginName})
            .then(res => {
              if (res.code == 0) {
                this.isSuccess = res.data
              } else {
                this.$message({
                  type: 'info',
                  message: '查询失败，请稍后再试！'
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('查询失败，请稍后再试！')
            })     
    },

     // 查询状态
    goToSettleInStep(){
      getMercharntStep({username:this.userInfo.loginName}) // username为账户名,后期需要改
            .then(res => {
              if (res.code == 0) {
                this.statusType(res.data)
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('查询失败，请稍后再试！')
            })     
    },

     // 查询支付保证金是否已支付
    getMarginStatus(){
      payMargin({uid:this.userInfo.userId})
            .then(res => {
              if (res.code == 0) {
                this.isPayMargin = res.data
                if(res.data ==2){ // 已支付
                    this.isdisabled = false
                }
                // this.statusType(res.data)
              }
            })     
    },
    // 点击支付保证金调起的按钮
    submitcanApply(){
       this.$refs.sizeForm.validate((valid) => {
        if (valid) {
          addMargin({
            remittanceUrl:this.payFormarginImg,
            amount:this.MarginMoney,
            muid:this.userInfo.userId,
          })
          .then(res=>{
            if(res.code==0){
              this.isShow = false
              this.paydialogcanVisible = false
              this.isdisabled = false
              this.$message.success("提交保证金凭据成功,请等待管理员审核!")
            }else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
          })
          } 
      });
    },
    // 确认支付 上传支付凭证
    submitApply(){
       this.$refs.sizeForm.validate((valid) => {
        if (valid) {
         merchantpayMoney({bxmId:this.payForList.bxmId,payForImg:this.payForImg})
            .then(res => {
              if (res.code == 0) {
                this.paydialogVisible = false;
                this.isPayMoney = false;  
                this.isSuccess  =  4  
                this.$message({
                  type: 'success',
                  message: res.msg
                })                
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('提交失败，请稍后再试！')
            })
          } 
      });
    },
      //   支付凭证上传
    handleAvatarSuccess(res, file) {
        console.log(res,file.raw,URL.createObjectURL(file.raw))
            this.urlImg = URL.createObjectURL(file.raw) // 用来图片预览的
            this.sizeForm.payproof =URL.createObjectURL(file.raw);
            this.payForImg = res.url
            localStorage.setItem("remittanceUrl", res.url)
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isLt2M;
        },

      //   支付保证金凭证上传
    handlemarginAvatarSuccess(res, file) {
            this.marginurlImg = URL.createObjectURL(file.raw) // 用来图片预览的
            this.sizeForm.paypmarginroof =URL.createObjectURL(file.raw);
            this.payFormarginImg = res.url
            localStorage.setItem("remittanceUrl", res.url)
        },
        beforemarginAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isLt2M;
        },
  },
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
.leftaside {
  width: 300px;
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  margin-right: 10px;
  margin-bottom: 40px;
  .el-submenu .el-menu-item {
    height: 25px;
    line-height: 25px;
  }
  /deep/.el-submenu__title,.el-menu-item {
    height: 40px;
    line-height: 40px;
  }
  /deep/.el-submenu__title:focus,
  /deep/.el-submenu__title:hover,
  /deep/.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow,
  /deep/.el-menu-item.is-active {
    color: #78b942;
  }  
}
.leftaside h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: 16px;
  font-weight: 700;
}

.rightaside{
    h3 {
    font-size: 14px;
    color: #333;
    padding: 14px;
    border-radius: 4px;
  }
  .payfor{
      color:#004cc4;
      text-decoration: underline;
  }
  .greenStatus{
      background: #e1f7d9;
      border: 1px solid #c4f9bc;
  }
  .blueStatus{
      background: #d9edf7;
      border: 1px solid #bce5f9;
  }
  .outBoxLine.el-row {
      border: 1px solid #ccc;
      border-bottom: none;

  }
  .titleBorderline{
    border-bottom: 1px solid #ccc;
    font-size: 18px;
    background: #e6e6e6;
    padding:14px;
    color:#333
 }
 .borderline {
    padding: 8px 14px;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
}
.total{
  text-align: right;
}
.payButton{
    text-align: right;
    padding: 20px;
    .el-button {
            background: #78b942;
            border: 1px solid #78b942;
            color: #ffffff;
          }
    }

}

.paydialogBox{
  p{
        font-size: 25px;
        margin: 50px 10px;
        i{
          font-size: 30px;
          font-weight: bold;
        }
  }
  /deep/label.el-form-item__label {
    font-size: 20px;
}
/deep/.el-dialog--center .el-dialog__body {
    text-align: initial;
    padding: 25px 25px 0px;
}
  /deep/.avatar-uploader {
              padding-bottom: 15px;
              box-sizing: border-box;
          }
      /deep/.el-upload.el-upload--text {
              border: 1px solid #ccc;
          }
 
      .avatar-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
          border-color: #409EFF;
      }
      .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 178px;
          height: 178px;
          line-height: 178px;
          text-align: center;
      }
      .avatar {
          width: 160px;
          height: 160px;
          display: block;
      }
      // .el-form-item.myproof.el-form-item--mini {
      //     border-bottom: 1px solid #ccc;
      // }
       button.el-button.buttonBgd.el-button--primary {
          background-color: #78b942;
          border-color: #78b942;
          font-size: 18px;
          margin: 20px 0;
      }

}


</style>

 
 

 


// WEBPACK FOOTER //
// src/views/merchantSettled/menchantpayFor.vue